<template>
    <div class="container-fluid search" id="search">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="row justify-content-between">
                    <div class="container-search col-xl-6 col-lg-12 col-md-12 col-sm-12">
                        <h2 v-if="!showHeading">Market Research</h2>

                        <div @keydown.enter="doSearch">
                            <table class="search">
                                <tr class="field-group">
                                    <td>
                                        <label for="make">Make</label>
                                    </td>

                                    <td class="field" colspan="3">
                                        <input type="text" class="form-control"
                                               readonly id="make"
                                               :value="makeString"
                                               :name="getNameField('make', selected_makes_proxy)"
                                               placeholder="Make"
                                               @click="show_make_modal = true">
                                        <b-modal size="lg" ref="ModalMake" id="modal-make" hide-footer title="Select make" v-model="show_make_modal" @hidden="onHideMakeModal">
                                            <div class="content-list-models">
                                                <div class="form-group inline-label">
                                                    <label for="models-in-modal">Make</label>
                                                    <input type="text" readonly id="makes-in-modal" :value="makeString" placeholder="Make">
                                                    <button type="button" class="link" @click="selected_makes_proxy = {}">Clear</button>
                                                    <button type="button" class="btn" @click="show_make_modal = false">Done</button>
                                                </div>
                                                <div class="list-of-models">
                                                    <template v-for="vehiclemake of makes">
                                                        <div class="model">
                                                            <span class="checkbox">
                                                                <input type="checkbox" :id="'make-'+vehiclemake.value" :value="vehiclemake.value" v-model="selected_makes_proxy[vehiclemake.value]" @change="onMakeChange">
                                                                <label :for="'make-'+vehiclemake.value">{{ vehiclemake.name }}</label>
                                                            </span>
                                                        </div>
                                                    </template>
                                                </div>
                                            </div>
                                        </b-modal>
                                    </td>
                                </tr>

                                <tr class="field-group">
                                    <td>
                                        <label for="model">Model</label>
                                    </td>
                                    <td class="field" colspan="3">
                                        <input type="text" class="form-control"
                                               readonly id="model"
                                               :value="modelString"
                                               :name="getNameField('model', selected_models_proxy)"
                                               placeholder="Model"
                                               @click="show_model_modal = true">
                                        <b-modal size="lg" ref="ModalModel" id="modal-model" hide-footer title="Select models" v-model="show_model_modal" @hidden="onHideModelModal">
                                            <div class="content-list-models">
                                                <div class="form-group inline-label">
                                                    <label for="models-in-modal">Models</label>
                                                    <input type="text" readonly id="models-in-modal" :value="modelString" placeholder="Models">
                                                    <button type="button" class="link" @click="selected_models_proxy = {}">Clear</button>
                                                    <button type="button" class="btn" @click="show_model_modal = false">Done</button>
                                                </div>

                                                <div class="loading-models" v-if="isModelLoading">
                                                    <img src="/images/loading.svg" width="50" alt="Loading">
                                                </div>

                                                <template v-else>

                                                    <div class="info-tabs info-single-vehicle">
                                                        <ul class="nav nav-tabs" role="tablist">
                                                            <li v-for="key in Object.keys(models)">
                                                                <a data-toggle="tab" :class="{ active: key === Object.keys(models).shift() }" :href="`#modelGroup${key.replace(' ', '')}`" role="tab">
                                                                    {{ key }}
                                                                </a>
                                                            </li>
                                                        </ul>

                                                        <div class="tab-content">
                                                            <template v-for="(vehiclemodellist, key) of models">
                                                                <div
                                                                    :id="`modelGroup${key.replace(' ', '')}`"
                                                                    :class="{
                                                                        'tab-pane': true,
                                                                        'active': key === Object.keys(models).shift(),
                                                                        'show': key === Object.keys(models).shift(),
                                                                        'fade': true
                                                                    }"
                                                                >
                                                                    <div class="list-of-models">
                                                                        <template v-for="vehiclemodel of vehiclemodellist">
                                                                            <div class="model">
                                                                            <span class="split-count">
                                                                                <template v-if="vehiclemodel.children && vehiclemodel.children.length">
                                                                                    <a href="#!" @click.prevent="openModelGroup(vehiclemodel.value)">{{ vehiclemodel.children.length }}</a>
                                                                                </template>
                                                                            </span>
                                                                            <span class="checkbox">
                                                                                <input type="checkbox" :id="'model-'+vehiclemodel.value" :value="vehiclemodel.value" v-model="selected_models_proxy[`${vehiclemodel.value}*`]">
                                                                                <label :for="'model-'+vehiclemodel.value">{{ vehiclemodel.name }} ({{ vehiclemodel.count }})</label>
                                                                            </span>
                                                                            </div>
                                                                            <template v-if="open_model_groups[vehiclemodel.value] && vehiclemodel.children && vehiclemodel.children.length">
                                                                                <div class="model" v-for="child in vehiclemodel.children">
                                                                                    <span class="split-count"></span>
                                                                                    <span class="split-count"></span>
                                                                                    <span class="checkbox">
                                                                                        <input type="checkbox" :id="'model-'+child.value.replace(' ', '')" :value="child.value" v-model="selected_models_proxy[child.value]">
                                                                                        <label :for="'model-'+child.value.replace(' ', '')">{{ child.name }}</label>
                                                                                    </span>
                                                                                </div>
                                                                            </template>
                                                                        </template>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </b-modal>
                                    </td>
                                </tr>
                                <tr class="field-group field-half">
                                    <td>
                                        <label for="year_min">Year</label>
                                    </td>
                                    <td class="field">
                                        <select id="year_min" :name="getNameField('year_min')" class="form-control" v-model="proxy_data.year_min" @change="onChange('year_min')">
                                            <option value="" selected>Min</option>
                                            <option v-if="!years.length" :value="proxy_data.year_min">{{proxy_data.year_min}}</option>
                                            <option v-for="year in years" :value="year">{{year}}</option>
                                        </select>
                                    </td>
                                    <td class="middle">
                                        <span>to</span>
                                    </td>
                                    <td class="field">
                                        <select id="year_max" :name="getNameField('year_max')" class="form-control"  v-model="proxy_data.year_max" @change="onChange('year_max')">
                                            <option value="" selected>Max</option>
                                            <option v-if="!years.length" :value="proxy_data.year_max">{{proxy_data.year_max}}</option>
                                            <option v-for="year in years" :value="year">{{year}}</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr class="field-group field-half">
                                    <td>
                                        <label for="condition_min">Condition <span class="show-tooltip" id="conditionToolTipPopup">?</span></label>
                                        <b-popover target="conditionToolTipPopup" title="" triggers="hover focus">
                                            <p><strong>Vehicle Condition</strong></p>
                                            <p>Each vehicle in an auction is given an overall condition rating by the auction house based on inspection.</p>
                                            <p>This is sometimes also refered to as a condition grade. Generally, the higher the number is, the better the quality of the car.</p>
                                            <p>Auction grades of 1.0 are a possible exceptions. 1.0 represents modified cars, which can actually be of a high quality, but the modifications make it difficult to compare such vehicles to their non-modified counterparts.</p>
                                            <p>Cars with condition 0.0 are accident and accident repaired cars. Cars with 0.1 are accident or accident reparied cars that have been modified.</p>
                                            <p>Cars with condition 5.0 are like new vehicles.</p>
                                            <p>Cars with condition 9.0 are usually new, or nearly new, vehicles.</p>
                                        </b-popover>
                                    </td>
                                    <td class="field">
                                        <select id="condition_min" :name="getNameField('condition_min')" class="form-control" v-model="proxy_data.condition_min" @change="onChange('condition_min')">
                                            <option value="">Min</option>
                                            <option :value="0">0.0</option>
                                            <option :value="2">2.0</option>
                                            <option :value="3">3.0</option>
                                            <option :value="3.5">3.5</option>
                                            <option :value="4">4.0</option>
                                            <option :value="4.5">4.5</option>
                                            <option :value="5">5.0</option>
                                            <option :value="9">9.0</option>
                                        </select>
                                    </td>
                                    <td class="middle"><span>to</span></td>
                                    <td class="field">
                                        <select id="condition_max" :name="getNameField('condition_max')" class="form-control" v-model="proxy_data.condition_max" @change="onChange('condition_max')">
                                            <option value="" selected>Max</option>
                                            <option :value="0">0.0</option>
                                            <option :value="2">2.0</option>
                                            <option :value="3">3.0</option>
                                            <option :value="3.5">3.5</option>
                                            <option :value="4">4.0</option>
                                            <option :value="4.5">4.5</option>
                                            <option :value="5">5.0</option>
                                            <option :value="9">9.0</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr class="field-group field-half">
                                    <td>
                                        <label for="mileage_min">Mileage</label>
                                    </td>
                                    <td class="field">
                                        <div class="inline-flex">
                                            <input type="text" id="mileage_min" class="form-control" v-model="proxy_data.mileage_min" @change="onChangeMinMax('mileage_min')"><span>,000</span>
                                        </div>
                                        <input type="hidden" :name="getNameField('mileage_min')" v-if="data.mileage_min" class="form-control" :value="data.mileage_min">
                                    </td>
                                    <td class="middle">
                                        <span>to</span>
                                    </td>
                                    <td class="field">
                                        <div class="inline-flex">
                                            <input type="text" id="mileage_max" class="form-control" v-model="proxy_data.mileage_max"  @change="onChangeMinMax('mileage_max')"><span>,000</span>
                                        </div>
                                        <input type="hidden" :name="getNameField('mileage_max')" v-if="data.mileage_max" class="form-control" :value="data.mileage_max">
                                    </td>
                                </tr>
                                <tr class="field-group">
                                    <td>
                                        <label for="transmission">Transmission</label>
                                    </td>
                                    <td class="field" colspan="3">
                                        <select id="transmission" class="form-control" name="transmission" v-model="proxy_data.transmission" @change="onChange('transmission')">
                                            <option value="" selected>All</option>
                                            <option value="1">Manual</option>
                                            <option value="2">Automatic</option>
                                            <option value="0">Unknown</option>
                                        </select>
                                    </td>
                                </tr>
                            </table>

                            <div class="form-row">
                                <div class="form-group col-sm-12 search-clear-buttons">
                                    <button type="submit" class="btn btn-primary" @click.prevent="doSearch">
                                        Search Vehicles
                                    </button>
                                    <br />
                                    <a href="#" class="link uppercase" @click.prevent="clearForm">Clear form</a>
                                </div>
                            </div>
                            <div class="advanced-options">
                                <h3>Advanced Options</h3>
                                <table class="search">
                                    <tr class="field-group">
                                        <td>
                                            <label for="excluded-makes">Exclude Makes</label>
                                        </td>
                                        <td class="field" colspan="3">
                                            <input type="text" class="form-control"
                                                   readonly
                                                   id="excluded-makes"
                                                   :name="getNameField('excluded_makes', objectToString(excluded_makes_proxy))"
                                                   placeholder="Excluded makes"
                                                   :value="objectToString(excluded_makes_proxy)"
                                                   @click="show_exlude_makes_modal = true" autocomplete="off">
                                            <b-modal size="lg"
                                                     ref="ExcludedModalMakes"
                                                     id="excluded-modal-makes"
                                                     title="Exclude Makes"
                                                     hide-footer
                                                     v-model="show_exlude_makes_modal"
                                                     @hidden="onHideExcludeMakesModal">
                                                <div class="content-list-models">
                                                    <div class="form-group inline-label">
                                                        <label for="excluded-makes-in-modal">Exclude Makes</label>
                                                        <input type="text" readonly id="excluded-makes-in-modal" :value="objectToString(excluded_makes_proxy)" placeholder="Excluded Makes">
                                                        <button type="button" class="link" @click="clearExcludeMakes">Clear</button>
                                                        <button type="button" class="btn" @click="show_exlude_makes_modal = false">Done</button>
                                                    </div>
                                                    <div class="list-of-models">
                                                        <div v-for="make in all_makes">
                                                          <span class="checkbox">
                                                               <input type="checkbox" :id="'excluded-makes-'+make.name" :value="make.name" v-model="excluded_makes_proxy[make.name]">
                                                               <label :for="'excluded-makes-'+make.name">{{ make.name }}</label>
                                                          </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-modal>
                                        </td>
                                    </tr>
                                    <tr class="field-group">
                                        <td>
                                            <label for="chassis">Chassis</label>
                                        </td>
                                        <td class="field" colspan="3">
                                            <input type="text" :name="getNameField('chassis')"  id="chassis" placeholder="Chassis" class="form-control" v-model="proxy_data.chassis" @change="onChange('chassis')">

                                        </td>
                                    </tr>
                                    <tr class="field-group field-half">
                                        <td>
                                            <label for="engine_cc_min">Engine CC</label>
                                        </td>
                                        <td class="field">
                                            <input type="text" :name="getNameField('engine_cc_min')" placeholder="Min" id="engine_cc_min" class="form-control" v-model="proxy_data.engine_cc_min" @change="onChange('engine_cc_min')">
                                        </td>
                                        <td class="middle">
                                            <span>to</span>
                                        </td>
                                        <td class="field">
                                            <input type="text" :name="getNameField('engine_cc_max')" placeholder="Max" id="engine_cc_max" class="form-control" v-model="proxy_data.engine_cc_max" @change="onChange('engine_cc_max')">
                                        </td>
                                    </tr>
                                    <tr class="field-group">
                                        <td>
                                            <label for="lot">Lot#</label>
                                        </td>
                                        <td class="field" colspan="3">
                                            <input type="text" :name="getNameField('lot')" id="lot" class="form-control" placeholder="Lot #, Lot #, Lot #, Lot #, Lot #" v-model="proxy_data.lot" @change="onChange('lot')">
                                        </td>
                                    </tr>
                                    <tr class="field-group">
                                        <td>
                                            <label for="fuel_type"><span>Fuel Type</span></label>
                                        </td>
                                        <td class="field" colspan="3">
                                            <select id="fuel_type" class="form-control" v-model="proxy_data.fuel_type" @change="onChange('fuel_type')">
                                                <option value="" selected>All</option>
                                                <option value="p">petrol / unspecified</option>
                                                <option value="d">diesel</option>
                                                <option value="o">other</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr class="field-group field-half">
                                        <td>
                                            <label for="start_bid_min">Start Bid (YEN)</label>
                                        </td>
                                        <td class="field">
                                            <input type="text" id="start_bid_min" class="form-control" v-model="proxy_data.start_bid_min" @change="onChangeMinMax('start_bid_min')" /><span>,000</span>
                                            <input type="hidden" :name="getNameField('start_bid_min')" v-if="data.start_bid_min" class="form-control" :value="data.start_bid_min + '000'">
                                        </td>
                                        <td class="middle">
                                            <span>to</span>
                                        </td>
                                        <td class="field">
                                            <input type="text" id="start_bid_max" class="form-control" v-model="proxy_data.start_bid_max" @change="onChangeMinMax('start_bid_max')" /><span>,000</span>
                                            <input type="hidden" :name="getNameField('start_bid_max')" v-if="data.start_bid_max" class="form-control" :value="data.start_bid_max + '000'">
                                        </td>
                                    </tr>
                                    <tr class="field-group">
                                        <td>
                                            <label for="colour">Colour</label>
                                        </td>
                                        <td class="field" colspan="3">
                                            <input type="text" :name="getNameField('colour')" id="colour" placeholder="Colour" class="form-control" v-model="proxy_data.colour" @change="onChange('colour')">
                                        </td>
                                    </tr>
                                    <tr class="field-group field-half">
                                        <td>
                                            <label for="exclude_year_min">Exclude Year</label>
                                        </td>
                                        <td class="field">
                                            <select id="exclude_year_min" name="exclude_year_min" class="form-control" v-model="proxy_data.exclude_year_min" @change="onChange('exclude_year_min')">
                                                <option value="" selected>Min</option>
                                                <option v-for="year in years" :value="year">{{year}}</option>
                                            </select>
                                        </td>
                                        <td class="middle">
                                            <span>to</span>
                                        </td>
                                        <td class="field">
                                            <select id="exclude_year_max" name="exclude_year_max"  class="form-control"  v-model="proxy_data.exclude_year_max" @change="onChange('exclude_year_max')">
                                                <option value="" selected>Max</option>
                                                <option v-for="year in years" :value="year">{{year}}</option>
                                            </select>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapState, mapMutations, mapActions } from 'vuex'
    import {getterSetter} from '../../util/vuex_setter_getter';
    import {objToUrl, storeLocalData} from "../../util/common";

    export default {
        props: ['value', 'hide_search_fields', 'past'],
        created(){
            if (!this.$_.isEmpty(this.$route.query)) {
                this.setSearch(this.$route.query)
            }
            this.$store.commit('market_research/setLoading', false)
            this.updateProxyData();
        },
        mounted(){
            this.$store.dispatch('market_research/maybeGetSearchData');
            // this.updateProxyData();

            if (this.$router.query && this.$router.query.iframe) {
                this.showHeading = false
            }
        },
        data(){
            return {
                dates : {},
                auctions : {},
                models : [],
                show_make_modal: false,
                show_model_modal: false,
                show_exlude_makes_modal: false,
                selected_models_proxy: {},
                selected_makes_proxy: {},
                open_model_groups: {},
                excluded_makes_proxy: {},
                proxy_data: {},
                model_list: [],
                isModelLoading : false,
                showHeading : false,
            }
        },
        computed: {
            ...mapState({
                years: state => state.market_research.years,
                data: state => state.market_research.search_data,
                makes: state => state.market_research.makes,
                all_makes: state => state.market_research.all_makes,
                loading: state => state.market_research.loading,
            }),
            modelString () {
                let models = []
                for (let key in this.selected_models_proxy) {
                    if (this.selected_models_proxy[key]) {
                        if (this.models[key]) {
                            models.push(key)
                        } else {
                            models.push(key)
                        }
                    }
                }
                return models.join(',')
            },
            makeString(){
                let makes = []
                for (let key in this.selected_makes_proxy) {
                    if (this.selected_makes_proxy[key]) {
                        if (this.makes[key]) {
                            makes.push(key)
                        } else {
                            makes.push(key)
                        }
                    }
                }
                const response = makes.join(',')
                this.make = response
                return response
            },
            makeNotExist(){
                let found = false
                if (this.makes && this.makes.length) {
                    this.makes.forEach(makes => {
                        if (makes && makes.options && makes.options.length) {
                            makes.options.forEach(inner_make => {
                                if (makes.value === this.proxy_data.make) {
                                    found = true
                                }
                            })
                        } else if (makes.value && makes.value === this.proxy_data.make) {
                            found = true
                        }
                    })
                }
                return !found
            },

        },
        methods: {
            ...mapMutations({
                resetSearch: 'market_research/resetSearch',
                setSearchProperty: 'market_research/setSearchProperty',
                setSearch: 'market_research/setSearch'
            }),
            ...mapActions({
                getSearchData: 'market_research/getSearchData',
                getModelsByMake: 'market_research/getModelsByMake',
            }),
            openModelGroup(model){
                let data = JSON.parse(JSON.stringify(this.open_model_groups));
                data[model] = !data[model];
                this.open_model_groups = data
            },
            maybeGroupModels(){
                if (this.data.make.length) {
                    const preparedModels = Object.fromEntries(this.data.make.split(',').map(make => [make, {}]))

                    this.data.make.split(',').forEach(make => {
                        Object.values(this.models[make]).forEach((model) => {
                            if (model.name.indexOf(' ') !== -1) {
                                const groupName = model.name.split(' ').shift()
                                if (preparedModels[make][groupName]) {
                                    preparedModels[make][groupName] = {
                                        ...preparedModels[make][groupName],
                                        count: preparedModels[make][groupName].count + model.count,
                                        children: [
                                            ...preparedModels[make][groupName].children,
                                            model
                                        ]
                                    }
                                }
                            } else {
                                preparedModels[make][model.name] = {
                                    ...model,
                                    children: []
                                }
                            }
                        })
                    })

                    this.models = preparedModels
                }
            },
            async updateProxyData(){
                let data = JSON.parse(JSON.stringify(this.data));
                if (data.start_bid_min && data.start_bid_min > 0) {
                    data.start_bid_min = data.start_bid_min / 1000;
                }
                if (data.start_bid_max && data.start_bid_max > 0) {
                    data.start_bid_max = data.start_bid_max / 1000;
                }
                if (data.mileage_min && data.mileage_min > 0) {
                    data.mileage_min = data.mileage_min / 1000;
                }
                if (data.mileage_max && data.mileage_max > 0) {
                    data.mileage_max = data.mileage_max / 1000;
                }
                let proxy_models = {};
                if (data.model && data.model.length) {
                    let models_arr = data.model.split(',');
                    models_arr.forEach(model => {
                        proxy_models[model] = true;
                    });
                }
                let proxy_makes = {};
                if (data.make && data.make.length) {
                    let makes_arr = data.make.split(',');
                    makes_arr.forEach(make => {
                        proxy_makes[make] = true;
                    });
                }
                let excluded_makes = {};
                if (data.excluded_makes && data.excluded_makes.length) {
                    data.excluded_makes.forEach(make => {
                        if (typeof make === 'string') {
                             excluded_makes[make] = true;
                        } else {
                            excluded_makes[make.name] = true;
                        }
                    });
                }
                this.isModelLoading = true;
                let models = await this.getModelsByMake({ make: data.make });
                this.isModelLoading = false;
                this.models = models;
                this.model_list = models;
                this.selected_models_proxy = proxy_models;
                this.selected_makes_proxy = proxy_makes
                this.excluded_makes_proxy = excluded_makes;
                this.proxy_data = data;
                this.maybeGroupModels()
            },
            async onChange(prop){
                this.setSearchProperty({
                    prop: prop,
                    value: this.proxy_data[prop]
                });
                await this.updateProxyData();
            },
            onChangeMinMax(prop){
                let value = this.proxy_data[prop] * 1000;
                this.setSearchProperty({
                    prop: prop,
                    value: value
                });
                this.updateProxyData();
            },
            /**
             * Only give the field a name if the value is populated
             * @param fieldname
             * @param value
             */
            getNameField(fieldname, value){
                /**
                 * Check if its in the data obj
                 */
                if (this.data[fieldname]) {
                    return fieldname;
                }
                if (!this.$_.isEmpty(value)) {
                    return fieldname;
                }
                return '';
            },
            objectToString(object){
                let array = this.objToArray(object);
                return array.join();
            },
            objToArray(object) {
                let array = [];
                for (const key of Object.keys(object)) {
                    if(object[key]){
                        array.push(key);
                    }
                }
                return array;
            },
            onHideMakeModal () {
                let tmp = this.objToArray(this.selected_makes_proxy);
                this.setSearchProperty({
                    prop: 'make',
                    value: tmp.join(',')
                });
                if (tmp.length) {
                    this.excluded_makes_proxy = {};
                }
                this.updateProxyData();
            },
            onHideModelModal(){
                let tmp = this.objToArray(this.selected_models_proxy);
                this.setSearchProperty({
                    prop: 'model',
                    value: tmp.join(',')
                });
                if (tmp.length) {
                    this.excluded_makes_proxy = {};
                }
                this.updateProxyData();
            },
            onHideExcludeMakesModal(){
                let tmp = this.objToArray(this.excluded_makes_proxy);
                this.setSearchProperty({
                    prop: 'excluded_makes',
                    value: tmp
                });
                this.updateProxyData();
            },
            async onMakeChange(){
                this.proxy_data['make'] = this.makeString
                await this.onChange('make');
                this.selected_models_proxy = {};
                this.setSearchProperty({
                    prop: 'model',
                    value: ''
                });

            },
            clearExcludeMakes(){
                this.excluded_makes_proxy = {};
                this.setSearchProperty({
                    prop: 'exclude_make',
                    value: null
                });
            },
            clearForm(){
                this.selected_makes_proxy = {};
                this.selected_models_proxy = {};
                this.excluded_makes_proxy = {};
                this.resetSearch();
                this.proxy_data = JSON.parse(JSON.stringify(this.data));
            },

            onExcludeSeen(){
                this.setSearchProperty({
                    prop: 'excludeSeen',
                    value: this.proxy_data.excludeSeen ? 1 : 0
                })
            },
            doSearch() {
                if (window.document.activeElement) {
                    window.document.activeElement.blur()
                }
                this.$nextTick(() => {
                    let args = {};
                    for (let field in this.data) {
                        if (this.data[field] !== null) {
                            if (!(Array.isArray(this.data[field]) && !this.data[field].length)) {
                                args[field] = this.data[field];
                            }
                        }
                    }
                    if (args.excluded_makes && args.excluded_makes.length) {
                        args.excluded_makes = args.excluded_makes.join(',');
                    }
                    //change to trigger build
                    if (window.location.search.indexOf('iframe') !== -1) {
                        args.iframe = 1
                    }
                    this.$store.commit('market_research/setCurrentPage', 1)
                    args.model = this.modelString
                    let query_string = objToUrl(args);
                    let base_url = this.$laravelRouter('auctions.marketResearchList', [], false);
                    let url = base_url + '?' + query_string;
                    this.axios.get(url);
                    this.$router.push(url);
                })
            },
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/Forms/MarketResearch.vue